// src/DashboardLayout.js
import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const ReducedContent = ({ children }) => {
  return (
    <div className="starter-template">
      <Row>
        <Col md={3}></Col>
        <Col md={5}>
          <br />
          <br />
          {children}
        </Col>
        <Col md={3}></Col>
      </Row>
    </div>
  );
};

export default ReducedContent;
